/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMaxRightIcon16Light = forwardRef('ArrowDim2DiagMaxRightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M14 6.5a.5.5 0 0 1-1 0V3.707L9.354 7.354a.5.5 0 1 1-.708-.708L12.293 3H9.5a.5.5 0 0 1 0-1H13a1 1 0 0 1 1 1v3.5Z" }),
        React.createElement("path", { d: "M7.354 8.646a.5.5 0 0 0-.708 0L3 12.293V9.5a.5.5 0 0 0-1 0V13a1 1 0 0 0 1 1h3.5a.5.5 0 0 0 0-1H3.707l3.647-3.646a.5.5 0 0 0 0-.708Z" })));
});
